import styled from 'styled-components'

export const Wrapper = styled.img`
  width: 80px;
  margin: auto;
  align-self: center;
  justify-self: center;
`
